import { FC, ReactElement } from "react";
import { CatHeading } from '@blocks-react/components/Heading';
import styles from "../NotificationFilterDrawer.module.scss";

export interface SearchContent {
    title: string;
    children: ReactElement;
    customClassName?: string
}

export const SearchContainer: FC<SearchContent> = ({ children, title, customClassName }) => {
    return (
        <div className={styles['search-container']}>
            <div className={`${customClassName || 'mx-4 py-4'}`}>
                <CatHeading variant="label">{title}</CatHeading>
                {children}
            </div>
        </div>
    )
}